module.exports = __webpack_public_path__ + "static/careers-ef3fa7fad9415f3e12653ce0eed5fbc1.svg";